module.exports = __webpack_public_path__ + "img/challenge-5-fr.fa1a9b4e.png";